import BaseModel from "../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";
import {EMAIL_REGEX} from "@/plugins/vee-validate";

export default class RecipientModel extends BaseModel {
  uuid = null
  type = null
  customer_uuid = null
  user_uuid = null
  display_name = null
  email = null
  routing_order = 1
  disabled = false

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    type: 'required',
    display_name: 'required|max:255',
    email: {
      regex: EMAIL_REGEX,
      max: 73,
      required: true
    },
    routing_order: 'min_value:1|integer|required'
  };

  attributeHints = {
  };

  attributeLabels = {
  };

  attributePlaceholders = {
    display_name: i18n.t('Display Name'),
    email: i18n.t('Email Address'),
    routing_order: i18n.t('Routing Order'),
  }
}
